import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';

export const usePresenter = () => {
  const { dispatch, fenceStore } = useStoreon<IState, IEvents>('fenceStore');

  const picketCoatingHandler = (picketCoating: string) => {
    dispatch('fence/set-picket-coating', { picketCoating });
  };
  const picketTypeHandler = (picketType: string) => {
    dispatch('fence/set-picket-type', { picketType });
  };

  return {
    picketCoating: fenceStore.picketCoating,
    picketType: fenceStore.picketType,
    picketCoatingHandler,
    picketTypeHandler,
  };
};
















